"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@cian/config/browser");
function setupWebpackPublicPath() {
    var config = browser_1.getConfig();
    var publicPath = config.getStrict('web.manifest.assetsBaseUrl');
    // eslint-disable-next-line @typescript-eslint/camelcase
    __webpack_public_path__ = publicPath;
}
exports.setupWebpackPublicPath = setupWebpackPublicPath;
//# sourceMappingURL=setup.js.map